module.exports = __webpack_public_path__ + "img/2x.8863217.jpg";